// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7093":"d7ec34fa","9989":"352708c2"}[chunkId] + ".chunk.css";
};